/**
 * @description
 * @author Jinishakappil
 *
 *  This Component is used to switch branches
 *
 *
 */
import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { Branch } from '../../../../models';

import { message, Select } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import { GlobalContext } from 'soxo-bootstrap-core';

import './branch-switcher.scss';

const { Option } = Select;

export default function BranchSwitcher({ callback }) {
    const [branches, setBranches] = useState([]);

    const [loading, setLoading] = useState(true);

    const { dispatch } = useContext(GlobalContext);

    // const [selected, setSelected] = useState(localStorage.db_ptr ? localStorage.db_ptr : process.env.REACT_APP_DB_PTR);

    const history = useHistory(); // ← get history
    const [selected, setSelected] = useState(localStorage.db_ptr || process.env.REACT_APP_DB_PTR);
    const initialDbptrRef = useRef(localStorage.getItem('db_ptr') || '');

    useEffect(() => {
        getBranches();
    }, []);

    let details;

    /**
     * Get Branch List
     */
   
    /**
     * Fetches branch list, initializes db_ptr, and updates state.
     */
    async function getBranches() {
        setLoading(true);
        try {
            const result = await Branch.getBranches();
            const details = result.result.map((ele) => ({
                ...ele,
                ...JSON.parse(ele.br_otherdet1),
            }));
            setBranches(details);

            let initialDBPtr = localStorage.getItem('db_ptr');
            if (!initialDBPtr && details.length) {
                initialDBPtr = details[0].index;
                localStorage.setItem('db_ptr', initialDBPtr);
                setSelected(initialDBPtr);
                callback(initialDBPtr);
                initialDbptrRef.current = initialDBPtr;
            }
        } catch (err) {
            message.error('Failed to load branches.');
        } finally {
            setLoading(false);
        }
    }

    /**
     * Selecting index of branches . And setting name of branch
     *
     * @param {*} value
     */
    function onBranchSwitching(index) {
        callback(index);
        // To check the access of switching loaction
        Branch.getProfile(index).then(async (result) => {
            if (result) {
                // The User info that we need to update to the store
                let userInfo = {
                    ...result,
                    ...{ loggedCheckDone: true },
                };

                localStorage.setItem('userInfo', JSON.stringify(userInfo));

                dispatch({ type: 'user', payload: userInfo });

                // callback(index);

                setSelected(index);

                /**Cheack if the user is logged in */
                if (userInfo.statusCode === 200) {
                    history.push('/');    //  navigation
                }
            }
        });
    }

    
    // Listen for localStorage changes across tabs
    useEffect(() => {
        /**
         * Event handler for storage changes.
         * Triggered when localStorage is modified in a different tab/window.
         *
         * @param {StorageEvent} event - The storage event containing key, oldValue, newValue, etc.
         */
        const handleStorageChange = (event) => {
            // Check if the changed key is 'db_ptr'
            if (event.key === 'db_ptr') {
                const newValue = event.newValue;

                // If the new value differs from the current selected value
                if (newValue !== selected) {
                    // Update the selected state with the new value
                    setSelected(newValue);

                    // Invoke the provided callback with the new value
                    callback(newValue);
                     history.push('/'); // ← also navigate in other tabs
                }
            }
        };

        // Attach the storage event listener
        window.addEventListener('storage', handleStorageChange);

        // Cleanup: Remove the storage event listener on unmount or dependency change
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [selected, callback]); // Dependencies: re-run effect if selected or callback changes

    return (
        <div className="branches">
            {loading ? (
                <LoadingOutlined></LoadingOutlined>
            ) : (
                <Select value={selected} onSelect={onBranchSwitching}>
                    {branches.map((ele, key) => {
                        return (
                            <Option key={key} value={ele.index}>
                                {ele.br_desc}
                            </Option>
                        );
                    })}
                </Select>
            )}
        </div>
    );
}
